import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

interface Props {
  buildInput: string;
}

const setGridColumn = (buildInput: string) => {
  if (buildInput === 'allBrand') {
    return '1fr 1fr 1fr';
  }
  return '1fr'
};

export const GridContent = styled.div`

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: grid;
    ${(props: Props) => props.buildInput && `
      grid-template-columns: ${setGridColumn(props.buildInput)};
    `}
    & > div {
      min-width: 118px;
    }

    & > div:not(:first-child) {
      margin-left: 15px;
    }
  }
`;